
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import InlineXNumber from 'vux/src/components/inline-x-number/index.vue'

import {
getPartyVoteList,
addVotePartyVotelog,
addCount
} from '@/api/youzheng'
import { nowInDateBetwen } from '@/libs/utils'
import { operateCreditlist } from '@/api/user'

export default {
props: ['partyObj'],
directives: {
TransferDom
},
components: {
XDialog,
Flexbox,
FlexboxItem,
InlineXNumber
},
data () {
return {
baseUrl: this.$config.baseUrl,
obj: [],
voted: 0, // 已投票数
showDialog: false,
partyid: this.$route.params.artid,
searchvalue: '',
noResult: false,
page: 1,
rows: 30,
num: '',
dialogobj: {},
dialogobjIndex: '',
votenum: 1,
voteTotal: 0, // 可投票数量
moremsg: '点击加载更多',
status: 0, // 0还未开始，1正在进行，-1结束
scroll: 0
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
activated () {
window.scroll(0, this.scroll)
},
mounted () {
this.status = nowInDateBetwen(
this.partyObj.votestartdate,
this.partyObj.voteenddate
)
this.loadList()
this.getCount()
},
methods: {
loadList () {
getPartyVoteList({
partyid: this.partyid,

username: this.searchvalue,
page: this.page,
rows: this.rows
}).then(data => {
if (!data.obj) return
this.num = data.msg
if (data.obj.length <= 0 && this.page === 1) {
this.obj = []
this.noResult = true
} else if (data.obj.length > 0 && this.page === 1) {
this.obj = data.obj
} else {
this.noResult = false
this.obj = this.obj.concat(data.obj)
this.moremsg = '点击加载更多'
}
})
},
loadmore () {
this.moremsg = '正在加载中'
this.page++
this.loadList()
},

vote () {
let voteids = []
for (let i = 0; i < this.votenum; i++) {
voteids.push(this.dialogobj.id)
}
addVotePartyVotelog({
partyid: this.partyid,
voteids: voteids.join(','),
openid: this.userid,
source: 1
})
.then(data => {
this.showDialog = false
this.$vux.toast.text('投票成功！')
this.$set(
this.obj[this.dialogobjIndex],
'tongji',
this.obj[this.dialogobjIndex].tongji + this.votenum
)
this.partyObj.totleVoteCnt += this.votenum
this.voteTotal -= this.votenum

operateCreditlist({
accountid: this.accountid,
rulecode: 'vote',
credit: 1,
owner_type: this.$config.owner_type,
terminaltype: 2
})
})
.catch(() => {
this.showDialog = false
})
},
detail (obj) {
this.scroll = document.documentElement.scrollTop || document.body.scrollTop
this.$router.push({
name: 'fathersdayDetail',
params: { voteid: obj.id }
})
},
search () {
this.page = 1
this.loadList()
},
showDialogFun (obj, index) {
this.dialogobj = obj
this.dialogobjIndex = index
this.showDialog = true
},

getCount () {
addCount({
partyid: this.partyid,
openid: this.userid
}).then(res => {
this.voteTotal = this.partyObj.voteMax - res.obj 
})
}
}
}
